"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fiftyModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const fiftyModuleFragment = exports.fiftyModuleFragment = (0, _fetching.gql)`
  fragment FiftyBanner on EditorialFiftyBanner {
    __typename
    editorialContentType
    backgroundImage {
      __typename
      url
      urlMobile
    }
    backgroundVideo {
      __typename
      id
      autoplayOnScroll
      playInLoop
      type
    }
    backgroundType
    contentAlignment
    id
    title
    link {
      __typename
      id
      relativeUrl
      title
      type
      appLink {
        __typename
        link
        deepLink
      }
    }
    storybookColor
    steps {
      __typename
      caption
      content {
        __typename
        text
        textLinks {
          __typename
          relativeUrl
          title
          type
        }
      }
    }
  }
`;
